import React from "react";
import { useTranslation } from 'react-i18next';
import ConnectionProgressStep from "./ConnectionProgressStep";

type ConnectionProgressIndicatorProps = {
    stepZeroStatus: 'completed' | 'in-progress' | 'upcoming';
    stepOneStatus: 'completed' | 'in-progress' | 'upcoming';
    stepTwoStatus: 'completed' | 'in-progress' | 'upcoming';
    stepThreeStatus: 'completed' | 'in-progress' | 'upcoming';
    setupSuccessful?: boolean;
}

const ConnectionProgressIndicator = ({
    stepZeroStatus,
    stepOneStatus,
    stepTwoStatus,
    stepThreeStatus,
    setupSuccessful = false,
}: ConnectionProgressIndicatorProps) => {
    const { t } = useTranslation();

    return (
        <div className="flex flex-col items-center py-2 bg-light-gray-button transition-colors duration-300">
            <div className="flex flex-col">
                <label className="mt-3 text-2xl text-off-black transition-colors duration-300">{t("Connection Quick Start")}</label>
                {setupSuccessful ?
                    <div className="my-2">
                        <ConnectionProgressStep
                            stepLabel={t("Success! Your connection is set up. Monitor the logs for status updates.")}
                            status="completed"
                            finalStep={true} />
                    </div> :
                    <div className="flex w-max h-14 items-center gap-4 p-4 my-2 bg-white rounded-lg">
                        <ConnectionProgressStep stepLabel={t("Select Provider")} status={stepZeroStatus} finalStep={false} />
                        <ConnectionProgressStep stepLabel={t("Configure Provider")} status={stepOneStatus} finalStep={false} />
                        <ConnectionProgressStep stepLabel={t("Connect Destination")} status={stepTwoStatus} finalStep={false} />
                        <ConnectionProgressStep stepLabel={t("Confirmation")} status={stepThreeStatus} finalStep={true} />
                    </div>}
            </div>
        </div>
    );
};

export default ConnectionProgressIndicator